import { useMemo } from 'react'
import { useAuth } from '@/providers/AuthProvider'
import { cgtUserFrom } from '@/lib/currentCgtUser'
import type { CgtUser } from '@/types/cgt'

/** The signed-in principal as the form renderer's `currentUser`. */
export function useCurrentCgtUser(): CgtUser {
  const { user, email } = useAuth()
  return useMemo(() => cgtUserFrom(user, email), [user, email])
}
